'use client';

import { useSupabaseStorageMonitor } from '@/lib/hooks/useSupabaseStorageMonitor';

/**
 * Supabase Storage Monitor Component
 *
 * Monitors Supabase auth storage errors and displays user-facing notifications
 * when authentication fails due to storage issues (quota exceeded, etc.)
 *
 * This component should be included at the root level of the application
 * to ensure auth storage errors are properly communicated to users.
 */
export default function SupabaseStorageMonitor() {
  useSupabaseStorageMonitor();
  return null; // This component only handles side effects
}
